module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrows-collapse-6069a14d.svg";